import { Link } from 'react-router-dom';

const Hero = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">
      {/* Background with subtle pattern */}
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
              <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="1"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" className="text-primary"/>
        </svg>
      </div>

      <div className="section-container relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
           
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
              Designing Destination Experiences
              <span className="block text-primary mt-2">Delivering them at Scale</span>
            </h1>
            
            <p className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl">
              We design, own, and scale destination-led travel experiences through trusted regional operators.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mb-8">
              <Link to="/contact" className="btn-primary text-center">
                <span className="flex items-center justify-center">
                  Start Partnership
                  <svg className="w-5 h-5 ml-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </span>
              </Link>
            </div>
            
            {/* Quick stats */}
            <div className="flex items-center space-x-8 mt-12">
              <div>
                <div className="text-2xl font-bold text-primary">IP-First</div>
                <div className="text-sm text-gray-500">Design Philosophy</div>
              </div>
              <div className="h-8 w-px bg-gray-300"></div>
              <div>
                <div className="text-2xl font-bold text-gray-900">B2B</div>
                <div className="text-sm text-gray-500">Partnership Focus</div>
              </div>
              <div className="h-8 w-px bg-gray-300"></div>
              <div>
                <div className="text-2xl font-bold text-secondary">Global</div>
                <div className="text-sm text-gray-500">Operator Network</div>
              </div>
            </div>
          </div>
          
          {/* Image showcase */}
          <div className="relative">
            <div className="grid grid-cols-2 grid-rows-2 gap-4 h-[500px]">
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <div className="absolute inset-0 bg-gradient-to-br from-amber-500/20 to-orange-600/20"></div>
                <div className="absolute inset-0 flex items-end p-6">
                  <div>
                    <div className="inline-flex items-center px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm mb-2">
                      <span className="text-xs font-medium text-white">Cultural</span>
                    </div>
                    <h3 className="text-white font-bold text-lg">West Africa Rendezvous</h3>
                  </div>
                </div>
                {/* Placeholder for actual image */}
                {/* <div className="w-full h-full bg-gradient-to-br from-amber-400 to-orange-500"></div> */}
                <div className="w-full h-full bg-gradient-to-br from-amber-400 to-orange-500"
                   style={{
                    backgroundImage: 'url("/assets/hero/cultural.jpeg")'
                  }}
                ></div>
              </div>
              
              <div className="relative rounded-2xl overflow-hidden shadow-xl">
                <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-indigo-600/20"></div>
                <div className="absolute inset-0 flex items-end p-6">
                  <div>
                    <div className="inline-flex items-center px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm mb-2">
                      <span className="text-xs font-medium text-white">European</span>
                    </div>
                    <h3 className="text-white font-bold text-lg">Boundless Experience</h3>
                  </div>
                </div>
                {/* <div className="w-full h-full bg-gradient-to-br from-blue-400 to-indigo-500"></div> */}
                <div 
                  className="w-full h-full bg-cover bg-center"
                  style={{
                    backgroundImage: 'url("/assets/hero/europe.jpeg")'
                  }}
                ></div>
              </div>
              
              <div className="relative rounded-2xl overflow-hidden shadow-xl col-span-2">
                <div className="absolute inset-0 bg-gradient-to-br from-emerald-500/20 to-teal-600/20"></div>
                <div className="absolute inset-0 flex items-end p-6">
                  <div>
                    <div className="inline-flex items-center px-3 py-1 rounded-full bg-white/20 backdrop-blur-sm mb-2">
                      <span className="text-xs font-medium text-white">Corporate & Diaspora</span>
                    </div>
                    <h3 className="text-white font-bold text-lg">Group Travel Formats</h3>
                  </div>
                </div>
                {/* <div className="w-full h-full bg-gradient-to-br from-emerald-400 to-teal-500"></div> */}
                <div 
                  className="w-full h-full bg-cover bg-center"
                  style={{
                    backgroundImage: 'url("/assets/hero/group_travel.jpeg")'
                  }}
                ></div>
              </div>
            </div>
            
            {/* Floating element */}
            <div className="absolute -right-4 -top-4 bg-white rounded-2xl shadow-xl p-4">
              <div className="text-center">
                <div className="text-xs text-gray-500 mb-1">Operators</div>
                <div className="text-2xl font-bold text-primary">50+</div>
                <div className="text-xs text-gray-500">Certified Partners</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;